<template>
  <add-or-edit-calc-modal
    :modal_title="isEdit ? 'Редактироваеие' : 'Добавить'"
    modal-id="calc-modal-add-edit"
    :form_fields="getFields"
    :def_form_obj="form_obj"
    @formSubmit="saveClick"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import addOrEditCalcModal from '@/components/validatedFormModal.vue'

export default {
  components: {
    addOrEditCalcModal,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    form_obj: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters('knowledgeBase', ['GET_PAYMENT_INTERESTS']),
    getFields() {
      return [
        {
          component_name: 'b-form-radio-group',
          obj_name: 'payment_in_percent',
          label: 'Оплата (%):',
          validation_rules: 'required',
          props: {
            options: this.GET_PAYMENT_INTERESTS,
            'text-field': 'value',
            'value-field': 'id',
          },
        },
        {
          obj_name: 'discount_in_percent',
          col_size: 6,
          validation_rules: 'required',
          label: 'Скидка (%):',
          props: {
            type: 'number',
          },
        },
        {
          obj_name: 'installment',
          col_size: 6,
          validation_rules: 'required',
          label: 'Рассрочка:',
          props: {
            type: 'number',
          },
        },
      ]
    },
  },
  mounted() {
    this.FETCH_PAYMENT_INTERESTS()
  },
  methods: {
    ...mapActions('knowledgeBase', ['FETCH_PAYMENT_INTERESTS']),
    ...mapActions('flats', ['ADD_FLAT_CALCULATION', 'UPDATE_FLAT_CALCULATION']),
    saveClick() {
      if (this.isEdit) {
        this.UPDATE_FLAT_CALCULATION(this.form_obj).then(() => {
          this.$_successToast('Успешно изменено')
          this.$emit('saveSuccess')
        }).catch(() => {
          this.$_errorToast('Ошибка')
        })
      } else {
        this.ADD_FLAT_CALCULATION(this.form_obj).then(() => {
          this.$_successToast('Успешно добавлено')
          this.$emit('saveSuccess')
        }).catch(() => {
          this.$_errorToast('Ошибка')
        })
      }
    },
  },
}
</script>

<style>

</style>
